export default __webpack_public_path__ + "static/media/arrow-down-white.c41f5df2.svg";